<template>
    <div>
        <div class="banner-ghost"></div>
        <img class="banner-img" :src="require('../assets/img/banners/' + imgPath)" alt="banner image">
        <img class="belasia-white-logo" :src="require('../assets/img/banners/belasia-white-logo.png')" alt="banner image">
        <h1 class="banner-txt">{{bannerText}}</h1>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line
    name: 'bottom',
    props: ['imgPath', 'bannerText']
}
</script>